export const GET_THEME = 'theme/GET_THEME';
export const CHANGE_THEME = 'theme/CHANGE_THEME';
